export const FETCH_WALLET_BALANCE_REQUEST = 'FETCH_WALLET_BALANCE_REQUEST';
export const FETCH_WALLET_BALANCE_SUCCESS = 'FETCH_WALLET_BALANCE_SUCCESS';
export const FETCH_WALLET_BALANCE_FAILURE = 'FETCH_WALLET_BALANCE_FAILURE';

export const WITHDRAW_FUNDS_REQUEST = 'WITHDRAW_FUNDS_REQUEST';
export const WITHDRAW_FUNDS_SUCCESS = 'WITHDRAW_FUNDS_SUCCESS';
export const WITHDRAW_FUNDS_FAILURE = 'WITHDRAW_FUNDS_FAILURE';

export const ADD_BANK_ACCOUNT_REQUEST = 'ADD_BANK_ACCOUNT_REQUEST';
export const ADD_BANK_ACCOUNT_SUCCESS = 'ADD_BANK_ACCOUNT_SUCCESS';
export const ADD_BANK_ACCOUNT_FAILURE = 'ADD_BANK_ACCOUNT_FAILURE';
